import { useIsVendorBooked } from '@pages/Storefront/containers/vendor_info/components/BookVendor/hooks/use-is-vendor-booked';
import { useAppSelector } from '@redux/hooks';
import { StatusBadge } from '@tkww/orion-web-ds';
import { TextBody } from '@tkww/orion-web-ds-text';
import React from 'react';
import Styles from './styles.scss';

export const VenueCard: React.FC = () => {
	const vendorRaw = useAppSelector((state) => state.vendor.vendorRaw);
	const bookings = useAppSelector((state) => state.bookings.bookings);
	const isVendorBooked = useIsVendorBooked(bookings, vendorRaw?.id);
	const vendorName = vendorRaw?.name;
	const imageUrl = vendorRaw?.storefrontCard?.url ?? '';

	return (
		<div className={Styles.venueCard} data-testid="venue-info-wrapper">
			<div className={Styles.venueImageWrapper}>
				<img src={imageUrl} alt={vendorName} className={Styles.venueImage} />
			</div>
			<div className={Styles.venueInfoWrapper}>
				{isVendorBooked && (
					<StatusBadge size="sm" styleType="positive">
						Booked
					</StatusBadge>
				)}
				<TextBody size="md" bold>
					{vendorName}
				</TextBody>
			</div>
		</div>
	);
};
